import { ModalButtonType } from '@philips-emr/tws-constants';
import { ModalService } from '@philips-emr/tws-core/lib/services';

import '../styles/dialog-style.scss';

class DialogService {

  static confirm(dialogDescription: string): Promise<void> {
    return new Promise((resolve, reject) => ModalService.openDialog({
      title: 'beneficiary.confirmacao',
      closeable: false,
      className: 'tws-dialog-service dialog-confirm',
      dialogDescription,
      dockButtons: [
        {
          title: 'beneficiary.fechar',
          type: ModalButtonType.CANCEL,
          action: reject,
        },
        {
          title: 'beneficiary.ok',
          type: ModalButtonType.SUCCESS,
          action: resolve,
        },
      ],
    }));
  }
}

export {
  DialogService,
};
